<template>
  <b-container fluid>
    <b-row class="justify-content-center">
      <b-col cols="12">
        
        <v-banner></v-banner>
        <v-introduction></v-introduction>
        <v-products></v-products>
        <v-services></v-services>
        <v-datas></v-datas> 
        <v-works></v-works>
        <v-slogan></v-slogan> 
      </b-col>
      <div class="w-100"></div>
    </b-row>
  </b-container>
</template>
<script>
  import Banner from './components/banner.vue'
  import Introduction from './components/introduce.vue'
  import Products from './components/products.vue'
  import Services from './components/services.vue'
  import Datas from './components/datas.vue'
  import Works from './components/works.vue'
  import Slogan from './components/slogan.vue'

export default {
  components: {
    'v-banner': Banner,
    'v-introduction': Introduction,
    'v-products': Products,
    'v-services': Services,
    'v-datas': Datas,
    'v-works': Works,
    'v-slogan': Slogan,
  },
  data() {
    return {
  
    };
  },
  watch: {},
  created() {
    console.log("/server/api/statistical/visits/website/search/get",);
    this.getVists()
  },
  mounted() {},
  methods: {
    async getVists() {
      const { data: res } = await this.$http.get(
        "/server/api/statistical/visits/website/search/get"
      );
      // 请求成功
      if (res.code == 200) {
        console.log("访问");
      }
    },
  },
};

</script>
<style>
@import "../../assets/css/index.css";
</style>
<style lang="less" scoped>
.wrap {
  text-align: center;
  /* background: #fafafa; */
}

</style>
